/**
 * DASHBOARD LAYOUT
 * Layout principal avec sidebar de navigation
 */

import { useNavigation } from '@/contexts/NavigationContext';
import type { ReactNode } from 'react';
import { NavigationFooter, NavigationHeader, NavigationSearch, NavSection } from '../navigation';

interface DashboardLayoutProps {
  children: ReactNode;
}

export default function DashboardLayout({ children }: DashboardLayoutProps) {
  const { config, state, setActiveItem } = useNavigation();
  const { activeItemId } = state;
  const { sections: navigationSections } = config;

  return (
    <div className="flex h-screen w-full">
      {/* Sidebar */}
      <aside className="flex flex-col gap-4 w-64 bg-neutral-50 border-r border-zinc-200 py-4">
        <div className="px-6">
          <NavigationHeader />
        </div>

        {/* Separator */}
        <div className="w-full h-px bg-zinc-200" />

        <div className="px-6">
          <NavigationSearch />
        </div>

        <div className="flex flex-col gap-4 flex-grow overflow-y-auto px-6">
          {navigationSections.map((section) => (
            <NavSection
              key={section.id}
              section={section}
              activeItemId={activeItemId}
              onItemClick={setActiveItem}
            />
          ))}
        </div>

        {/* Separator */}
        <div className="w-full h-px bg-zinc-200" />

        <div className="px-6">
          <NavigationFooter />
        </div>
      </aside>

      {/* Main Content */}
      <main className="flex-grow overflow-auto">{children}</main>
    </div>
  );
}
